import { render, staticRenderFns } from "./OrganisationTypeCard.vue?vue&type=template&id=762f7fab&scoped=true"
import script from "./OrganisationTypeCard.vue?vue&type=script&lang=js"
export * from "./OrganisationTypeCard.vue?vue&type=script&lang=js"
import style0 from "./OrganisationTypeCard.vue?vue&type=style&index=0&id=762f7fab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f7fab",
  null
  
)

export default component.exports